import ConversationSortOrder from 'owa-service/lib/contract/ConversationSortOrder';
import ItemId from 'owa-service/lib/contract/ItemId';

/**
 * This enum stores persistent state of current GCI call
 */
export enum HasLoadState {
    /**
     * GCI call is not triggered
     */
    notStarted,
    /**
     * GCI call failed with error
     */
    hasFailed,
    /**
     * GCI call is successfully completed
     */
    hasSucceeded,
}

/**
 * Interface containing loading state of current GCI call
 */
export interface LoadingState {
    /**
     * GCI call is currently in progress, promise is pending resolution
     */
    isLoading: boolean;
    /**
     * Persistent state of the current GCI call
     */
    hasLoadState: HasLoadState;
}

/**
 * This enum stores the current state of conversation request
 */
export enum PendingConversationRequestState {
    /**
     * No GCI calls are pending
     */
    NotPending,
    /**
     * GCI call(s) pending with a valid conversation syncState
     */
    Pending,
    /**
     * GCI call(s) pending with no syncState
     */
    PendingAndUseEmptySyncState,
}

/**
 * Interface containing conversation info
 */
interface ConversationItemParts {
    conversationId: ItemId;
    /**
     * Array of internet message ids corresponding to conversation nodes
     */
    conversationNodeIds: string[];
    conversationSortOrder: ConversationSortOrder;
    canLoadMore: boolean;
    isLoadMoreInProgress: boolean;
    maxItemsToReturn: number;
    /**
     * Loading state of GCI call triggered for the conversation
     */
    loadingState: LoadingState;
    /**
     * State denoting any pending GCI calls which have been deferred until we get response for the current call.
     */
    pendingRequestState: PendingConversationRequestState;
    /**
     * Unique string denoting the Sync State value obtained from server as part of GCI response message
     * This value denotes current state of conversation info in server.
     * If we make multiple GCI calls for the same conversation id to fetch more nodes
     * or to get latest update on conversation we pass old syncState in the request
     */
    syncState?: string;
}

export default ConversationItemParts;
